import { Gallery } from "../gallery/gallery";
import { KnowMoreButton } from "../home/knowMoreButton";
import "./details.css";

export const Details = () => {
  return (
    <>
      <section class="ceremonies-section">
        <h2>Ceremonies</h2>
        <div class="ceremonies-content">
          <div class="ceremony">
            <h3>Gruhapravesam</h3>
            <p>
              A traditional housewarming ceremony, Gruhapravesam purifies and
              blesses a new home to ensure peace, prosperity, and happiness. It
              marks the auspicious entry of the family into the new space,
              invoking divine protection and blessings.
            </p>
          </div>
          <div class="ceremony">
            <h3>Marriage</h3>
            <p>
              A sacred union of two souls, the Marriage ceremony involves
              various rituals, including the Saptapadi (seven vows) and the
              tying of the mangalsutra, to invoke divine blessings for a happy
              and prosperous married life.
            </p>
          </div>
          <div class="ceremony">
            <h3>Namakaranam</h3>
            <p>
              The Namakaranam is the naming ceremony for a newborn, where the
              child is officially given a name, invoking blessings for health,
              wisdom, and a bright future.
            </p>
          </div>
          <div class="ceremony">
            <h3>Aksharabhyasam</h3>
            <p>
              The Aksharabhyasam marks a child’s first learning experience,
              where they are introduced to writing, symbolizing the beginning of
              their educational journey with divine blessings for knowledge and
              success.
            </p>
          </div>
          <div class="ceremony">
            <h3>Anna Prashana</h3>
            <p>
              This ceremony celebrates a child’s first intake of solid food,
              symbolizing the child's growth and development. It is conducted to
              seek blessings for the child’s health and prosperity.
            </p>
          </div>
          <div class="ceremony">
            <h3>Nischitartham</h3>
            <p>
              A pre-marriage engagement ritual where the families of the bride
              and groom formally announce the union. It is a sacred pledge for a
              future together, invoking blessings for a harmonious life.
            </p>
          </div>
        </div>
        <KnowMoreButton text="Contact Us" href="contact" />
      </section>
      <section class="pujas-section">
        <h2>Pujas</h2>
        <div class="pujas-content">
          <div class="puja">
            <h3>Ganapati Puja</h3>
            <p>
              Ganapati Puja is performed to invoke the blessings of Lord Ganesha
              for the removal of obstacles and the success of new endeavors. It
              is widely celebrated during Ganesh Chaturthi and other auspicious
              occasions.
            </p>
          </div>
          <div class="puja">
            <h3>Lakshmi Puja</h3>
            <p>
              A ritual dedicated to Goddess Lakshmi, the deity of wealth and
              prosperity, Lakshmi Puja is performed to seek divine blessings for
              abundance, happiness, and good fortune, especially during Diwali
              and other festivals.
            </p>
          </div>
          <div class="puja">
            <h3>Ayudha Puja</h3>
            <p>
              This puja honors tools, vehicles, and instruments, offering
              prayers for their longevity and effectiveness. It is performed on
              Vijayadashami (Dussehra) to celebrate success in work and
              business.
            </p>
          </div>
          <div class="puja">
            <h3>Rudra Puja</h3>
            <p>
              Dedicated to Lord Shiva in his Rudra form, Rudra Puja is performed
              to seek divine blessings for health, peace, and spiritual growth.
              It is known for its powerful impact on removing obstacles and
              enhancing spiritual well-being.
            </p>
          </div>
          <div class="puja">
            <h3>Satya Narayana Puja</h3>
            <p>
              This puja is performed to seek blessings from Lord Satyanarayana
              for happiness, peace, and fulfillment of desires. It is often
              performed on auspicious days like Purnima and Ekadashi.
            </p>
          </div>
          <div class="puja">
            <h3>Punyaha Vachanam</h3>
            <p>
              A purification ritual conducted to cleanse the body and soul,
              Punyaha Vachanam is performed during the commencement of new
              projects or major life events, inviting purity and divine
              blessings.
            </p>
          </div>
        </div>
        <KnowMoreButton text="Contact Us" href="contact" />
      </section>

      <section class="homas-section">
        <h2>Homas</h2>
        <div class="homas-content">
          <div class="homa">
            <h3>Ganapati Homam</h3>
            <p>
              A powerful fire ritual dedicated to Lord Ganesha, Ganapati Homam
              removes obstacles and ensures success in personal and professional
              endeavors. It is performed to gain divine protection and
              blessings.
            </p>
          </div>
          <div class="homa">
            <h3>Lakshmi Homa</h3>
            <p>
              A sacred ritual performed to invoke the blessings of Goddess
              Lakshmi for wealth, prosperity, and overall success. It is often
              performed during auspicious times like Diwali and other festive
              occasions.
            </p>
          </div>
          <div class="homa">
            <h3>Chandi Homa</h3>
            <p>
              Chandi Homa is a potent fire ritual performed to invoke the
              blessings of Goddess Durga and ensure the removal of obstacles,
              doshas, and negative energies, bringing prosperity and spiritual
              growth.
            </p>
          </div>
          <div class="homa">
            <h3>Pratyangira Homa</h3>
            <p>
              This powerful Homa is performed to remove evil influences and to
              protect the individual or family from negativity. It is known for
              its power in safeguarding the devotee from spiritual harm and
              distress.
            </p>
          </div>
          <div class="homa">
            <h3>Lakshmi Ganapati Homam</h3>
            <p>
              This Homa is a combination of two powerful rituals—one dedicated
              to Goddess Lakshmi and the other to Lord Ganapati. It is performed
              to bring both wealth and remove obstacles in business, home, and
              personal life.
            </p>
          </div>
          <div class="homa">
            <h3>Ayushya Homa</h3>
            <p>
              A ritual dedicated to the prolongation of life, Ayushya Homa is
              performed for the health and well-being of individuals. It seeks
              divine blessings for longevity and protection from untimely death
              or illness.
            </p>
          </div>
          <div class="homa">
            <h3>Vastu Shanti Homa</h3>
            <p>
              This Homa is performed to create harmony in new homes or
              properties. It eliminates negative energies and invites peace and
              prosperity into the living space, ensuring the well-being of the
              residents.
            </p>
          </div>
          <div class="homa">
            <h3>Mrityunjaya Homa</h3>
            <p>
              Dedicated to Lord Shiva, this Homa is performed to seek divine
              blessings for health, longevity, and protection from untimely
              death. It is a powerful ritual known for its healing and
              life-preserving qualities.
            </p>
          </div>
          <div class="homa">
            <h3>Dhanvantari Homa</h3>
            <p>
              Performed to invoke Lord Dhanvantari, the deity of health, this
              Homa is done for the recovery of ill individuals and to seek
              protection from health problems, ensuring well-being and vitality.
            </p>
          </div>
          <div class="homa">
            <h3>Sudarshana Homa</h3>
            <p>
              A powerful fire ritual dedicated to Lord Sudarshana, an aspect of
              Lord Vishnu, Sudarshana Homa is performed to remove negative
              influences, enemies, and spiritual obstacles while ensuring peace
              and protection.
            </p>
          </div>
        </div>
        <KnowMoreButton text="Contact Us" href="contact" />
      </section>
      <section class="shantis-section">
        <h2>Shantis</h2>
        <div class="shantis-content">
          <div class="shanti">
            <h3>Shashti Poorthi</h3>
            <p>
              This ceremony marks the completion of 60 years in a person’s life,
              symbolizing a new phase of spiritual growth, well-being, and
              blessings. It is performed to seek divine grace for a healthy,
              prosperous future.
            </p>
          </div>
          <div class="shanti">
            <h3>Navagraha Shanti</h3>
            <p>
              Navagraha Shanti is a ritual performed to seek the blessings of
              the nine planets (Navagraha) for the removal of doshas, ensuring
              peace, prosperity, and positive energy flow in the individual’s
              life.
            </p>
          </div>
          <div class="shanti">
            <h3>Bheema Ratha Shanthi</h3>
            <p>
              A ceremony performed for individuals who have crossed 72 years of
              age, Bheema Ratha Shanthi is conducted to honor the life journey
              and invoke divine blessings for health, longevity, and spiritual
              upliftment.
            </p>
          </div>
          <div class="shanti">
            <h3>Sahasra Chandra Darshana Shanthi</h3>
            <p>
              This ritual is performed after 1000 full moon nights, marking a
              significant spiritual milestone. It involves offering prayers for
              peace, spiritual awakening, and health.
            </p>
          </div>
          <div class="shanti">
            <h3>Nakshatra Shanti</h3>
            <p>
              Nakshatra Shanti is performed to mitigate the malefic effects of
              certain stars or constellations in one’s birth chart. It helps
              bring balance, remove obstacles, and enhance prosperity.
            </p>
          </div>
        </div>
        <KnowMoreButton text="Contact Us" href="contact" />
      </section>
      <Gallery />
    </>
  );
};
